import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetReviewersArgsType = GetRequestArgsType & {
  reviewCode: string;
};

export type PostReviewerPayloadType = {
  tenantUserId: number;
};

export type PostReviewerArgsType = PostRequestArgsType<PostReviewerPayloadType> & {
  reviewCode: string;
};

export type DeleteReviewerArgsType = DeleteRequestArgsType & {
  reviewCode: string;
  reviewerId: number;
};

export const apiFetchReviewers = async ({
  domain = useTenantStore().domain,
  reviewCode,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetReviewersArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.reviewers({ domain, reviewCode }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateReviewer = async ({
  domain = useTenantStore().domain,
  reviewCode,
  payload,
  validateStatus = null,
  errorConfig = {},
  callbacks = {},
}: PostReviewerArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.reviewers({ domain, reviewCode }),
      payload,
      validateStatus,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteReviewer = async ({
  domain = useTenantStore().domain,
  reviewCode,
  reviewerId,
  errorConfig = {},
  callbacks = {},
}: DeleteReviewerArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.reviewers({ domain, reviewCode, reviewerId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
